import React, { useState } from 'react';
import './Realify.css';

const Realify = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the email to your backend
    console.log('Email submitted:', email);
    setSubscribed(true);
    setEmail('');
  };

  return (
    <div className="realify-container">
      {/* Deepfake Themed Background */}
      <div className="deepfake-background">
        {/* Neural Network Grid */}
        <div className="neural-grid"></div>
        
        {/* Face Morph Effect */}
        <div className="face-morph"></div>
        
        {/* Floating Particles */}
        {[...Array(100)].map((_, i) => (
          <div 
            key={i} 
            className="deepfake-particle" 
            style={{
              '--random-x': Math.random() * 2 - 1,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${8 + Math.random() * 12}s`
            }}
          ></div>
        ))}
      </div>

      <div className="realify-content">
        {/* Branding - Logo Removed */}
        <div className="realify-brand">
          <h1 className="realify-title">REALIFY</h1>
          <p className="realify-tagline">Advanced Deep Fake Detection</p>
        </div>

        {/* Main Content */}
        <div className="realify-main">
          <h2 className="coming-soon-title">Coming Soon</h2>
          <p className="coming-soon-description">
            We're building the next generation of deep fake detection technology 
            to protect digital authenticity and combat misinformation.
          </p>

          {/* Email Subscription */}
          <div className="subscription-section">
            {!subscribed ? (
              <>
                <p className="subscription-text">
                  Be the first to know when we launch. Join our waitlist!
                </p>
                <form onSubmit={handleSubmit} className="subscription-form">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                    className="email-input"
                  />
                  <button type="submit" className="subscribe-btn">
                    Notify Me
                  </button>
                </form>
              </>
            ) : (
              <div className="success-message">
                <span className="success-icon">✅</span>
                <p>Thank you! We'll notify you when we launch.</p>
              </div>
            )}
          </div>
        </div>

        {/* Social Links */}
        <div className="social-links">
          <a href="https://twitter.com" className="social-link" target="_blank" rel="noopener noreferrer">
            <span className="social-icon">🐦</span>
            Twitter
          </a>
          <a href="https://linkedin.com" className="social-link" target="_blank" rel="noopener noreferrer">
            <span className="social-icon">💼</span>
            LinkedIn
          </a>
          <a href="mailto:info@realify.ai" className="social-link">
            <span className="social-icon">📧</span>
            Email
          </a>
        </div>

        {/* Footer */}
        <footer className="realify-footer">
          <p>&copy; 2024 REALIFY. Protecting digital authenticity.</p>
        </footer>
      </div>
    </div>
  );
};

export default Realify;
